import apiClient from "./apiClient";
const resource = "/vendors";

export default {
  async getAll() {
    return apiClient.get(`${resource}`);
  },
  async create(data) {
    return apiClient.post(`${resource}`, data);
  },
  async getById(uuid) {
    return apiClient.get(`${resource}/${uuid}`);
  },
  async update(data, uuid) {
    return apiClient.put(`${resource}/${uuid}`, data);
  },
  async delete(uuid) {
    return apiClient.delete(`${resource}/${uuid}`);
  },
  async search(keyword) {
    return apiClient.get(`${resource}/search?keyword=${keyword}`);
  },
};
